import * as React from "react";
import Severity from "../commons/model/treatment/Severity";

interface SeverityMarkProps {
  severity: Severity;
  printMode?: boolean;
}

export default function SeverityMark({ severity, printMode }: SeverityMarkProps) {
  const printNumberOfMarks = {
    [Severity.SEVERE]: 3,
    [Severity.LIGHT]: 2,
    [Severity.NORMAL]: 1,
    [Severity.NONE]: 0,
  };

  return printMode ? (
    <div className="severity">
      {[...Array(printNumberOfMarks[severity])].map((e, i) => (
        <div key={i} className={`severity-${severity.toLowerCase()}`} />
      ))}
    </div>
  ) : (
    <div className="severity group">
      <div className={`severity-${severity.toLowerCase()}`} />
    </div>
  );
}
